import api from './api';
import { ApiResponse, PageResponse } from '../types/api';
import {
  CategoryRequestDTO,
  CategoryResponseDTO,
  CategoryFilters,
} from '../types/category';

const baseUrl = '/v1/categorias';

export const categoryService = {
  // Listar categorias com paginação e filtros
  async list(params?: {
    page?: number;
    size?: number;
    sort?: string;
    direction?: 'asc' | 'desc';
    filters?: CategoryFilters;
  }): Promise<ApiResponse<PageResponse<CategoryResponseDTO>>> {
    const searchParams = new URLSearchParams();

    if (params?.page !== undefined) searchParams.append('page', params.page.toString());
    if (params?.size !== undefined) searchParams.append('size', params.size.toString());
    if (params?.sort) searchParams.append('sort', params.sort);
    if (params?.direction) searchParams.append('direction', params.direction);

    // Filtros
    const filters: CategoryFilters = params?.filters || {};
    if (filters.nome) searchParams.append('nome', String(filters.nome));
    if (filters.ativo !== undefined) searchParams.append('ativo', String(filters.ativo));
    if (filters.categoriaPaiId) searchParams.append('categoriaPaiId', String(filters.categoriaPaiId));
    if (filters.categoriaPai) searchParams.append('categoriaPai', String(filters.categoriaPai));

    const queryString = searchParams.toString();
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    const response = await api.get<ApiResponse<PageResponse<CategoryResponseDTO>>>(url);
    return response.data;
  },

  // Buscar categoria por ID
  async getById(id: string): Promise<ApiResponse<CategoryResponseDTO>> {
    const response = await api.get<ApiResponse<CategoryResponseDTO>>(`${baseUrl}/${id}`);
    return response.data;
  },

  // Criar nova categoria
  async create(data: CategoryRequestDTO): Promise<ApiResponse<CategoryResponseDTO>> {
    const response = await api.post<ApiResponse<CategoryResponseDTO>>(baseUrl, data);
    return response.data;
  },

  // Atualizar categoria
  async update(id: string, data: CategoryRequestDTO): Promise<ApiResponse<CategoryResponseDTO>> {
    const response = await api.put<ApiResponse<CategoryResponseDTO>>(`${baseUrl}/${id}`, data);
    return response.data;
  },

  // Excluir categoria
  async delete(id: string): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${baseUrl}/${id}`);
    return response.data;
  },

  // Ativar categoria
  async activate(id: string): Promise<ApiResponse<CategoryResponseDTO>> {
    const response = await api.patch<ApiResponse<CategoryResponseDTO>>(`${baseUrl}/${id}/ativar`);
    return response.data;
  },

  // Desativar categoria
  async deactivate(id: string): Promise<ApiResponse<CategoryResponseDTO>> {
    const response = await api.patch<ApiResponse<CategoryResponseDTO>>(`${baseUrl}/${id}/desativar`);
    return response.data;
  },

  // Pesquisar categorias por nome/descrição
  async search(query: string, params?: { page?: number; size?: number }): Promise<ApiResponse<PageResponse<CategoryResponseDTO>>> {
    const searchParams = new URLSearchParams();
    searchParams.append('q', query);
    if (params?.page !== undefined) searchParams.append('page', params.page.toString());
    if (params?.size !== undefined) searchParams.append('size', params.size.toString());
    const response = await api.get<ApiResponse<PageResponse<CategoryResponseDTO>>>(`${baseUrl}/pesquisar?${searchParams.toString()}`);
    return response.data;
  },

  // Listar categorias ativas
  async listActive(params?: { page?: number; size?: number }): Promise<ApiResponse<PageResponse<CategoryResponseDTO>>> {
    const searchParams = new URLSearchParams();
    if (params?.page !== undefined) searchParams.append('page', params.page.toString());
    if (params?.size !== undefined) searchParams.append('size', params.size.toString());
    const response = await api.get<ApiResponse<PageResponse<CategoryResponseDTO>>>(`${baseUrl}/ativas?${searchParams.toString()}`);
    return response.data;
  },
};

export default categoryService;